import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasEmpleadoprestamosCotizadorDetalleComponent () {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges

  function $onInit () {
    calcular()
  }

  function $onChanges (changes) {
    if (changes.data) {
      $ctrl.data = changes.data.currentValue || null
    }

    calcular()
  }

  function calcular () {
    $ctrl.detalles = []
    let saldo = $ctrl.importeSolicitado
    let interes_acumulativo = 0
    for (let i = 0; i < $ctrl.plazo.meses; i++) {
      interes_acumulativo += (saldo * ($ctrl.data.tasa / 12))
      $ctrl.detalles.push({
        pago: i + 1,
        saldo_inicial: saldo,
        saldo_final: saldo - ($ctrl.data.mensualidad - (saldo * ($ctrl.data.tasa / 12))),
        pago_mensual_programado: $ctrl.data.mensualidad,
        interes: saldo * ($ctrl.data.tasa / 12),
        capital: $ctrl.data.mensualidad - (saldo * ($ctrl.data.tasa / 12)),
        interes_acumulativo: interes_acumulativo,
      })
      saldo -= $ctrl.data.mensualidad - (saldo * ($ctrl.data.tasa / 12))
    }
  }
}

module.component('finanzasEmpleadoprestamosCotizadorDetalle', {
  controller: FinanzasEmpleadoprestamosCotizadorDetalleComponent,
  template,
  bindings: {
    data: '<',
    importeSolicitado: '<',
    plazo: '<',
  },
})




// WEBPACK FOOTER //
// ./src/finanzas/_/empleadoprestamos/components/cotizador/detalle/component.js